import Memory from '@/lib/memory'

const STORAGE_KEY = 'moveProNativeSyncLock'
const OWNER = 'movepro-native-sync'

export const MOVE_PRO_NATIVE_SYNC_LOCK_TTL_MS = 35000
export const MOVE_PRO_NATIVE_SYNC_HEARTBEAT_MS = 1000
export const MOVE_PRO_NATIVE_SYNC_ACTIVE_STATES = new Set(['prepared', 'syncing'])

const buildExpiresAt = () => Date.now() + MOVE_PRO_NATIVE_SYNC_LOCK_TTL_MS

const normalizeLock = (lock) => {
    if (!lock || typeof lock !== 'object') return null
    if (lock.owner !== OWNER) return null

    const expiresAt = Number(lock.expiresAt)
    if (!Number.isFinite(expiresAt)) return null

    return {
        owner: OWNER,
        runId: lock.runId || null,
        deviceId: lock.deviceId || null,
        startedAt: Number(lock.startedAt) || Date.now(),
        renewedAt: Number(lock.renewedAt) || Date.now(),
        expiresAt,
    }
}

export const getMoveProNativeSyncLock = async ({ includeExpired = false } = {}) => {
    const lock = normalizeLock(await Memory.get(STORAGE_KEY, { otherwise: null }))

    if (!lock) {
        await Memory.remove(STORAGE_KEY)
        return null
    }

    if (!includeExpired && lock.expiresAt <= Date.now()) {
        await Memory.remove(STORAGE_KEY)
        return null
    }

    return lock
}

export const acquireMoveProNativeSyncLock = async ({ runId = null, deviceId = null } = {}) => {
    const now = Date.now()
    const lock = {
        owner: OWNER,
        runId,
        deviceId,
        startedAt: now,
        renewedAt: now,
        expiresAt: buildExpiresAt(),
    }

    await Memory.set(STORAGE_KEY, lock)
    return lock
}

export const renewMoveProNativeSyncLock = async ({ runId = null, deviceId = null } = {}) => {
    const existingLock = await getMoveProNativeSyncLock({ includeExpired: true })
    const now = Date.now()
    const lock = {
        owner: OWNER,
        runId: runId || existingLock?.runId || null,
        deviceId: deviceId || existingLock?.deviceId || null,
        startedAt: existingLock?.startedAt || now,
        renewedAt: now,
        expiresAt: buildExpiresAt(),
    }

    await Memory.set(STORAGE_KEY, lock)
    return lock
}

export const releaseMoveProNativeSyncLock = async ({ runId = null } = {}) => {
    const lock = await getMoveProNativeSyncLock({ includeExpired: true })

    if (lock?.runId && runId && lock.runId !== runId) {
        return lock
    }

    await Memory.remove(STORAGE_KEY)
    return null
}
